function maxWidthMd(fc1, fc2) {
    fc2 = fc2 || (function(){});
    if (ww <= screenMd) {
        fc1();
    } else {
        fc2();
    }
};

function maxWidthSm(fc1, fc2) {
    fc2 = fc2 || (function(){});
    if (ww <= screenSm) {
        fc1();
    } else {
        fc2();
    }
};

function checkWindowWidth(fc1, fc2, fc3) {
    fc1 = fc1 || (function(){});
    fc2 = fc2 || (function(){});
    fc3 = fc3 || (function(){});

    if (ww <= screenSm) {
        fc1();
    } else if ((ww <= screenMd)) {
        fc2();
    } else {
        fc3();
    }
}
